var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBellOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1314_24391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79992 1.99999C6.40246 1.60319 7.1011 1.37673 7.82185 1.34461C8.5426 1.3125 9.25862 1.47591 9.89407 1.81755C10.5295 2.15919 11.0607 2.66633 11.4315 3.28526C11.8022 3.90419 11.9986 4.61187 11.9999 5.33333C12.001 6.45635 12.1352 7.57528 12.3999 8.66666M11.3333 11.3333H1.99992C1.99992 11.3333 3.99992 10 3.99992 5.33333C3.99558 4.9464 4.0634 4.56206 4.19992 4.2M6.86659 14C6.97817 14.203 7.14222 14.3722 7.34158 14.4901C7.54094 14.608 7.76831 14.6702 7.99992 14.6702C8.23153 14.6702 8.4589 14.608 8.65826 14.4901C8.85762 14.3722 9.02166 14.203 9.13325 14M1.33325 1.33333L14.6666 14.6667",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1314_24391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellOff);
export default __webpack_public_path__ + "static/media/icon_bell_off.be6352af547ee1c766dd871f5ef29175.svg";
export { ForwardRef as ReactComponent };